import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-staff/interviewinfo/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export default {
  getList,
};
